export default "__VITE_ASSET__D8Spc5LK__"